// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9db44906","455":"4a3cc9b1"}[chunkId] + ".chunk.js";
};